import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";

export default function ExportChooser({
  open,
  onClose,
  onDownload,
  onEmail,
  initialFormat = "csv",
  disableDownload = false,
}) {
  const { t } = useCustomTranslation("Transactions");
  const [selectedFormat, setSelectedFormat] = useState(initialFormat);

  useEffect(() => {
    setSelectedFormat(initialFormat);
  }, [initialFormat]);

  return (
    <Dialog open={open} onClose={onClose} sx={{ "& .MuiDialog-paper": { minWidth: 420 } }}>
      <DialogTitle>{t("transactions_table_export_dialog_title")}</DialogTitle>
      <DialogContent>
        <div className="flex items-stretch justify-between gap-4 mt-2">
          <Button
            variant="contained"
            fullWidth
            onClick={() => onDownload(selectedFormat)}
            disabled={disableDownload}
            sx={{ height: 64 }}
          >
            {t("transactions_export_download") || "Download"}
          </Button>
          <Button variant="outlined" fullWidth onClick={onEmail} sx={{ height: 64 }}>
            {t("transactions_export_email") || "Email"}
          </Button>
        </div>

        <Divider sx={{ my: 3 }} />

        <div className="flex flex-col">
          <div className="font-medium mb-1">
            {t("transactions_export_format_label") || "File format"}
          </div>
          <RadioGroup
            value={selectedFormat}
            onChange={(e) => {
              setSelectedFormat(e.target.value);
            }}
          >
            <FormControlLabel value="csv" control={<Radio />} label="CSV" />
            <FormControlLabel value="xlsx" control={<Radio />} label="XLSX" />
          </RadioGroup>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onClose}>
          {t("transactions_export_close") || "Close"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
